// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EEPA","clinicsSelect":"styles_clinicsSelect__hRYSp"};